/* eslint-disable @typescript-eslint/no-explicit-any */
import type { ReactText } from 'react';
import type { AxiosError, AxiosResponse } from 'axios';
import { toast } from 'react-toastify';
import Cookie from 'js-cookie';
import { goToOrigin } from '@/_utils/navigation';
import { COOKIE_TOKEN_KEY, LOCALSTORAGE_URL_API_KEY } from '@/_constants/keys';
import { ErrorMessage } from './error-message';

const NETWORK_ERROR = 'Network Error';
export const HEADER_TOTAL_COUNT = 'x-total-count';

let networkErrorToastId: ReactText | null = null;

export const _handleInterceptResponseSuccess = async (
  response: AxiosResponse,
) => {
  if (networkErrorToastId) {
    toast.dismiss(networkErrorToastId);
    networkErrorToastId = null;
  }

  const { data: responseData } = response;

  if (responseData.errors) {
    const { errors, message } = responseData;

    const error = new Error(
      message || errors?.join(' - ') || 'Ocorreu um erro na sua solicitação.',
    );

    return Promise.reject(error);
  }

  return response;
};

export const handleInterceptResponseSuccess = async (
  response: AxiosResponse,
) => {
  if (networkErrorToastId) {
    toast.dismiss(networkErrorToastId);
    networkErrorToastId = null;
  }

  const { data: responseData } = response;

  if (responseData.errors) {
    const { errors, message } = responseData;

    const error = new Error(
      message || errors?.join(' - ') || 'Ocorreu um erro na sua solicitação.',
    );

    return Promise.reject(error);
  }

  return response.data;
};

export const handleInterceptResponseError = async (error: AxiosError) => {
  if (error.response) {
    const {
      response: { status, data },
    } = error;

    switch (status) {
      case 400:
        if ((data as any)?.errors) {
          toast.warn(<ErrorMessage errors={(data as any)?.errors} />);
        }
        break;
      case 401:
        Cookie.remove(COOKIE_TOKEN_KEY);
        goToOrigin();
        break;
      case 403:
        toast.warn(`[403] Sem permissão`);
        Cookie.remove(COOKIE_TOKEN_KEY);
        goToOrigin();
        break;
      case 404:
        if ((data as any)?.message) {
          toast.warn((data as any).message);
        }
        localStorage.removeItem(LOCALSTORAGE_URL_API_KEY);
        break;
      case 503:
        toast.info('Sistema em manutenção, tente novamente em instantes', {
          autoClose: false,
        });
        break;
      default:
        break;
    }
  } else if (error.message == NETWORK_ERROR) {
    if (networkErrorToastId) toast.update(networkErrorToastId);
    else
      networkErrorToastId = toast('📡❗️ Sem conexão com o servidor', {
        autoClose: false,
      });
  }

  return Promise.reject(error);
};
